<template>
  <div v-if="!overridesAvailable">
    <SectionHeader
      :show-content="bidDurationSettingsShowContents"
      :widget-title="$t('HEADER_BID_DURATION_SETTINGS')"
      @onShowContentsClick="onBidDurationSettingsShowContentsClick()"
    >
      <template #content>
        <form
          role="form"
          class="form-horizontal"
          name="bidDurationSettings"
        >
          <Field
            :label="$t('LABEL_BID_GOOD_FOR')"
            :hide-label="false"
            :has-tooltip="true"
            :tooltip-text="$t('TOOLTIP_BID_GOOD_FOR')"
          >
            <template #element>
              <ValidationProvider
                v-slot="{ classes, errors }"
                :rules="bidExpirationRule"
                slim
              >
                <div class="p-l-0 col-sm-5 col-md-1">
                  <input
                    :value="bidExpirationInSeconds"
                    name="bidExpirationInSeconds"
                    data-cy="bidExpirationInSeconds"
                    :disabled="affiliateView"
                    :placeholder="$t('LABEL_PLACEHOLDER_BID_GOOD_FOR')"
                    class="form-control"
                    :class="classes"
                    type="number"
                    @input="onBidGoodForOnInput"
                    @change="onBidGoodForOnChange"
                    @wheel="$event.target.blur()"
                  >
                </div>
                <label class="m-t-10">seconds</label>
                <label
                  v-if="errors[0]"
                  name="bidExpirationInSeconds-invalid-label"
                  data-cy="bidExpirationInSeconds-invalid-label"
                  class="form-group__label-required vv-invalid"
                >{{ bidExpirationValidationError }}
                </label>
                <label
                  v-else
                  class="form-group__label-required p-l-10"
                >{{ $t('REQUIRED') }}
                </label>
              </ValidationProvider>
            </template>
          </Field>

          <Field
            v-if="!affiliateView"
            :label="$t('LABEL_ROUTE_CALLS_FOR_STALE_BIDS')"
            :hide-label="false"
            :has-tooltip="true"
            :tooltip-text="$t('TOOLTIP_ROUTE_CALLS_FOR_STALE_BIDS')"
          >
            <template #element>
              <ValidationProvider
                rules="required"
                slim
              >
                <MultipleToggle
                  :value="routeCallsForStaleBids"
                  :options="routeCallsForStaleBidsOptions"
                  :disabled="affiliateView"
                  @onToggle="onRouteCallsForStaleBidsChange"
                />
              </ValidationProvider>
            </template>
          </Field>
        </form>
      </template>
    </SectionHeader>
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

import SectionHeader from '@/core/components/SectionHeader/SectionHeader';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle';

export default {
  name: 'BidDurationSettings',
  components: { SectionHeader, Field, MultipleToggle },
  props: {
    bidExpirationInSeconds: {
      type: String,
      default: () => {
        return '20';
      }
    },
    routeCallsForStaleBids: {
      type: Boolean,
      default: () => {
        return null;
      }
    },
    overridesAvailable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    affiliateView: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    callerIdRequired: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      bidDurationSettingsShowContents: true,
      routeCallsForStaleBidsOptions: Object.freeze([{ name: this.$t('MULTIPLE_TOGGLE_OPTIONS_REJECT'), value: false }, { name: this.$t('MULTIPLE_TOGGLE_OPTIONS_ROUTE_NORMALLY'), value: true }])
    };
  },
  computed: {
    bidExpirationRule() {
      const baseRule = 'required|min_value:0|integer';

      if (!this.callerIdRequired) {
        return baseRule + '|max_value:3600';
      }

      return baseRule;
    },
    bidExpirationValidationError() {
      if (this.callerIdRequired) {
        return this.$t('ERROR_BID_EXPIRATION_WITH_CID');
      }

      return this.$t('ERROR_BID_EXPIRATION');
    }
  },  
  methods:{
    onBidDurationSettingsShowContentsClick() {
      this.bidDurationSettingsShowContents = !this.bidDurationSettingsShowContents;
    },
    onBidGoodForOnInput(val) {
      this.$emit('onBidGoodForOnInput', val);
    },
    onBidGoodForOnChange(val) {
      this.$emit('onBidGoodForOnChange', val);
    },
    onRouteCallsForStaleBidsChange(val) {
      this.$emit('onRouteCallsForStaleBidsChange', val);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>